export default {
  //----
  credentialsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '24px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'right',
    flex: 1,
    marginTop: 16,
    gap: 16,
  },
  port: {
    maxWidth: 100,
  },
  s3User: {
    maxWidth: 150,
  },
  inputContainer: {
    flex: 1,
    width: '80%',
    maxWidth: '80%',
    padding: 8,
    boxSizing: 'border-box',
  },
  header: {
    marginBottom: 8,
    fontWeight: 'bold',
  },
};
